export type NotificationFlag =
  | 'METER_HEALTH_SUMMARY'
  | 'INSTALL_HEALTH_SUMMARY'
  | 'LEAK'
  | 'HIGH_USAGE'
  | 'MESSAGES_SEEN_EVENT'
  | 'METER_MODE_ACHIEVED_EVENT'
  | 'INITIAL_METER_HEALTHY_EVENT'
  | 'METER_UNHEALTHY_EVENT'
  | 'METER_HEALTHY_EVENT';

export interface UserAccountUpdateBody {
  note: string; // empty string allowed by us; BE allows string|null
  enabled_email_notifications: NotificationFlag[];
  enabled_sms_notifications: NotificationFlag[];
}

export function serializeUserAccountUpdate(input: {
  note?: string | null | undefined;
  emailFlags?: unknown;
  smsFlags?: unknown;
}): UserAccountUpdateBody {
  const email = Array.isArray(input.emailFlags) ? (input.emailFlags as NotificationFlag[]) : [];
  const sms = Array.isArray(input.smsFlags) ? (input.smsFlags as NotificationFlag[]) : [];
  const note = (input.note ?? '').toString().trim();

  return {
    note, // always a string per our contract ("" if blank)
    enabled_email_notifications: email,
    enabled_sms_notifications: sms,
  };
}
